import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import StyledLink from "../../../shared/StyledLink/StyledLink";
import { wwdData } from "../data";
import "./whatWeDo.scss";

const WhatWeDo = () => {
  return (
    <div className="home-whatwedo">
      <div className="text">
        <h1 className="big-title">
          <FormattedMessage
            id="home-whatwedo-title"
            defaultMessage="What we "
          />
          <span className="text-border">
            <FormattedMessage id="home-whatwedo-title2" defaultMessage="do" />
          </span>
        </h1>
        <p className="def-text">
          <FormattedMessage
            id="For"
            defaultMessage="For more than 5 years, our agency has created successful products through masterful SEO strategy, data-backed UI/UX design, cutting-edge technology and lasting support."
          />
        </p>
      </div>

      <div className="flex">
        {wwdData.map((props, i) => {
          return (
            <div key={i} className="whatwedoCard">
              <div className="border2"></div>
              <h1 className="small-title">{props.title}</h1>
              <div className="border">
                <div className="border-img"></div>
                <p className="def-text">{props.text}</p>
                <Link className="def-text" to="/">
                  <FormattedMessage
                    id="LearnMore"
                    defaultMessage="Learn More"
                  />
                </Link>
              </div>
            </div>
          );
        })}
      </div>

      <StyledLink
        to="/"
        styles="styled"
        linkName={
          <FormattedMessage id="ViewServices" defaultMessage="View services" />
        }
      />
    </div>
  );
};

export default WhatWeDo;
